/**
 * 순수 TypeScript 이벤트 에미터
 * DOM이나 Node.js 의존성 없이 동작
 */
export class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }
    /**
     * 이벤트 리스너 등록
     * @returns 리스너 제거 함수
     */
    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);
        return () => this.off(event, callback);
    }
    /**
     * 일회성 이벤트 리스너 등록
     */
    once(event, callback) {
        const wrapper = ((...args) => {
            this.off(event, wrapper);
            callback(...args);
        });
        return this.on(event, wrapper);
    }
    /**
     * 이벤트 리스너 제거
     */
    off(event, callback) {
        this.listeners.get(event)?.delete(callback);
    }
    /**
     * 이벤트 발생
     */
    emit(event, ...args) {
        this.listeners.get(event)?.forEach(callback => {
            try {
                callback(...args);
            }
            catch (error) {
                console.error(`[EventEmitter] Error in listener for "${String(event)}":`, error);
            }
        });
    }
    /**
     * 특정 이벤트의 모든 리스너 제거
     */
    removeAllListeners(event) {
        if (event) {
            this.listeners.delete(event);
        }
        else {
            this.listeners.clear();
        }
    }
    /**
     * 리스너 개수 확인
     */
    listenerCount(event) {
        return this.listeners.get(event)?.size ?? 0;
    }
}
//# sourceMappingURL=EventEmitter.js.map